'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _currencies = require('../../../common/utils/currencies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentsDueDirective = function () {
  function PaymentsDueDirective($state) {
    _classCallCheck(this, PaymentsDueDirective);

    this.getLongCurrencyForDues = function (feisCurrencyCode) {
      return (0, _currencies.getLongCurrency)(feisCurrencyCode);
    };

    this._ = { $state: $state };

    if (this.paymentsDue) {
      this.total = this.getTotal(this.paymentsDue);
    }
  }

  _createClass(PaymentsDueDirective, [{
    key: 'getTotal',
    value: function getTotal(paymentsDue) {
      return paymentsDue.map(function (d) {
        return d.balance.balance;
      }).reduce(function (prev, curr) {
        return prev + curr;
      }, 0);
    }
  }, {
    key: 'go',
    value: function go(state, params, $event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }

      this._.$state.go(state, params);
    }
  }]);

  return PaymentsDueDirective;
}();

exports.default = angular.module('ifeis.dashboard-payments-due', []).directive('fPaymentsDue', function () {
  return {
    bindToController: true,
    controller: 'PaymentsDueDirective',
    controllerAs: 'dues',
    replace: true,
    scope: {
      paymentsDue: '=',
      user: '='
    },
    template: require('./tpl.html')
  };
}).controller('PaymentsDueDirective', PaymentsDueDirective);


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/payments-due/index.js
// module id = 527
// module chunks = 0